//import hook react
import React, { useState, useEffect } from 'react';

//import hook useHitory from react router dom
import { useHistory } from 'react-router';

import queryString from 'query-string'
import { useLocation } from 'react-router-dom'

//import axios
import axios from 'axios';

function ForgotPassword() {

    //define state
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");

    const { search } = useLocation();
    const values = queryString.parse(search);

    const [formState, setFormState] = useState("");
    const [password, setPassword] = useState("");
    const [passwordConfirmation, setPasswordConfirmation] = useState("");

    //define state validation
    const [validation, setValidation] = useState([]);

    //define history
    const history = useHistory();

    //hook useEffect
    useEffect(() => {
        //check token
        if (localStorage.getItem(process.env.REACT_APP_TOKEN_NAME)) {

            //redirect page dashboard
            history.push('/dashboard');
        }
        console.log(values.uid);
        if (values.uid == undefined) {
            setMessage("Silakan masukkan email lengkap Anda.");
            setFormState("Forgot Password");
        }
        else {
            checkValidLink();
        }
    }, []);



    //function "checkValidLink"
    const checkValidLink = async () => {
        //send data to server
        await axios.get(process.env.REACT_APP_API_URL + '/forgotpassword/isvalid/' + values.uid)
            .then((response) => {
                console.log('valid');
                setMessage("Silakan ganti password Anda.");
                setFormState("Change Password");
            })
            .catch((error) => {
                console.log('invalid');
                setMessage(error.response.data.message);
                setFormState("Forgot Password");
            })
    }

    //function "forgotPasswordHandler"
    const forgotPasswordHandler = async (e) => {
        e.preventDefault();

        //initialize formData
        const formData = new FormData();

        //append data to formData
        formData.append('email', email);

        //send data to server
        await axios.post(process.env.REACT_APP_API_URL + '/forgotpassword', formData)
            .then((response) => {
                setMessage(response.data.message);
                setValidation([]);
                setEmail("");
            })
            .catch((error) => {
                //assign error to state "validation"
                setValidation(error.response.data);
            })
    };

    //function "changeNewPasswordHandler"
    const changeNewPasswordHandler = async (e) => {
        e.preventDefault();

        //initialize formData
        const formData = new FormData();

        //append data to formData
        formData.append('password', password);
        formData.append('password_confirmation', passwordConfirmation);

        //send data to server
        await axios.post(process.env.REACT_APP_API_URL + '/forgotpassword/' + values.uid, formData)
            .then((response) => {
                setMessage('Berhasil ganti password.');
                setValidation([]);
                setEmail("");
                setFormState("Berhasil");
            })
            .catch((error) => {
                //assign error to state "validation"
                setValidation(error.response.data);
            })
    }

    const backToLogin = () => {
        history.push('/login');
    }

    return (
        <div className="container" style={{ marginTop: "10px" }}>
            <div className="row justify-content-center">
                <div className="col-md-4">
                    <div className="card border-0 rounded shadow-sm">
                        <div className="card-body">
                            <div className="text-center text-dark mb-4 mt--4">
                                <div className="text-center">
                                    <img className="mb-3" src="logo1.png" width="150" alt=""></img>
                                    <h4 className="fw-bold">Single Sign On</h4>
                                </div>
                            </div>
                            <div className="text-center" style={{ fontSize: "15px" }}> {message} </div>

                            <hr />
                            {
                                validation.message && (
                                    <div className="alert alert-danger">
                                        {validation.message}
                                    </div>
                                )
                            }

                            {
                                formState == "Forgot Password"

                                    ?

                                    <form onSubmit={forgotPasswordHandler}>
                                        <div className="mb-3">
                                            <label className="form-label">EMAIL</label>
                                            <input type="text" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Masukkan Email" />
                                        </div>
                                        {
                                            validation.email && (
                                                <div className="alert alert-danger">
                                                    {validation.email[0]}
                                                </div>
                                            )
                                        }

                                        <div className="d-grid gap-2">
                                            <button type="submit" className="btn btn-primary btn-lg btn-block">
                                                Kirim Link Bantuan
                                            </button>
                                            <br></br>
                                            <div className="text-center" style={{ fontSize: "15px" }}> atau </div>
                                            <br></br>
                                            <button
                                                className="btn btn-outline-primary btn-lg btn-block"
                                                onClick={() => backToLogin()}>
                                                Kembali ke halaman login
                                            </button>
                                        </div>
                                    </form>

                                    :
                                    formState == "Change Password"
                                        ?
                                        <form onSubmit={changeNewPasswordHandler}>
                                            <div className="col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label">PASSWORD</label>
                                                    <input type="password" className="form-control" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Masukkan Password" />
                                                </div>
                                                {
                                                    validation.password && (
                                                        <div className="alert alert-danger">
                                                            {validation.password[0]}
                                                        </div>
                                                    )
                                                }
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label">KONFIRMASI PASSWORD</label>
                                                    <input type="password" className="form-control" value={passwordConfirmation} onChange={(e) => setPasswordConfirmation(e.target.value)} placeholder="Masukkan Konfirmasi Password" />
                                                </div>
                                            </div>

                                            <div className="d-grid gap-2">
                                                <button type="submit" className="btn btn-primary btn-lg btn-block">Ganti Password</button>
                                            </div>
                                        </form>
                                        :
                                        <div>
                                            <br></br>
                                            <button
                                                className="btn btn-outline-primary btn-lg btn-block"
                                                onClick={() => backToLogin()}>
                                                Kembali ke halaman login
                                            </button>
                                        </div>
                            }




                            <div className="text-center mt-2 mb-4">
                                &copy; {new Date().getFullYear()} &nbsp;
                                <a href="https://bpti.uhamka.ac.id/" target="_blank">
                                    BPTI UHAMKA
                                </a>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default ForgotPassword;